import { useContext, useState } from 'react'
import Radio from '../../../../Components/Radio/Radio'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import FirstDataPageNode from '../FirstDataPageView/FirstDataPageView'
import './HomeUseView.css'

interface Props {
	//onNext: () => void
}

const HomeUseView = (props: Props) => {
	let context = useContext(ConfiguratorContext)

	let [state, setState] = useState(context.isHomeUse)

	context.validateHomeUse = () => {
		context.isHomeUse = state
		return true
	}

	return (
		<ImageLayout src="../assets/home.png">
			<div className="home-use-container">
				<div className="home-use-title">Connessione per uso domestico?</div>
				<div className="home-use-subtitle">seleziona SI se sei un privato, NO se sei un libero professionista o
					un'azienda</div>
				<div className='home-use-radio-group'>
					<Radio title="SI" onChange={() => setState(true)} checked={state} />
					<Radio title='NO' onChange={() => setState(false)} checked={!state} />
				</div>
			</div>
		</ImageLayout>
	)
}

const HomeUseNode: NavigationNode = {
	content: () => <HomeUseView />,
	percentage: 9,
	previous: (context: Configuration) => ViewType.verifyCoverage,
	next: (context: Configuration) => ViewType.firstDataPage
}

export default HomeUseNode
